import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import __ from '../../helpers/translation';
import { useScheduledReportStore, reportStatus } from '../../lib/stores/scheduledReport'

const propTypes = {
  onStartNew: PropTypes.func.isRequired,
};

function ReportGenerated(props) {

  const { scheduledReports } = useScheduledReportStore()

  const isGeneratedOffline = useMemo(() => {
    if(!window.navigator.onLine) {
      return scheduledReports.find(report => report.status === reportStatus.COMPLETED_OFFLINE) ? true : false
    }
    return false
  }, [ scheduledReports ])

  return (
    <div className="loader bg-green-gradient tw-z-50 w-100 h-100">
      <div className="centered-container mw-sm-400 px-4 px-sm-0 w-100">
        <svg width="100" enableBackground="new 0 0 24 24" id="Layer_1" version="1.0" viewBox="0 0 24 24" xmlSpace="preserve">
          <polyline className="animated-check" fill="none" points="20,6 9,17 4,12" stroke="#ffffff" strokeMiterlimit="10" strokeWidth="3"></polyline>
        </svg>

        <h3 className="!tw-mt-4 !tw-mb-1 !tw-text-xl !tw-font-bold">
          {isGeneratedOffline 
            ? __('app.inspections.report_saved_offline')
            : __('app.inspections.report_generated')
          }
        </h3>

        <p className="!tw-mb-6 !tw-text-base">
          {isGeneratedOffline
            ? __('app.inspections.report_saved_offline_desc')
            : __('app.inspections.report_generated_desc')
          }
        </p>

        <button onClick={() => props.onStartNew()} className="btn btn-black btn-block text-nowrap">
          {__('app.inspections.start_new')}
        </button>

      </div>
    </div>
  )
}

ReportGenerated.propTypes = propTypes;

export default ReportGenerated;
